import { render } from "./editor.vue?vue&type=template&id=049409fb&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=049409fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049409fb"]])

export default __exports__